var _circle, _path, _path2, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarPredeterminado(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "283.46px",
    height: "283.46px",
    viewBox: "0 0 283.46 283.46",
    enableBackground: "new 0 0 283.46 283.46",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#BEAC83",
    cx: 141.73,
    cy: 141.73,
    r: 141.73
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M34.398,234.292c107.332-157.292,214.664,0,214.664,0s-36.64,49.168-107.332,49.168 C71.037,283.46,34.398,234.292,34.398,234.292"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEAC83",
    stroke: "#000000",
    strokeMiterlimit: 10,
    d: "M249.062,234.292"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#666666",
    cx: 141.729,
    cy: 93.692,
    r: 70.692
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarPredeterminado);
export default __webpack_public_path__ + "static/media/Avatar_predeterminado.9746204b365788cd9922c102448142d4.svg";
export { ForwardRef as ReactComponent };